import { fanWorks, trendingList } from "@/mocks/naruto";

export default function Latest() {
  const latest = fanWorks.slice(0, 6);

  return (
    <section id="latest" className="bg-background-50 py-14 md:py-20">
      <div className="mx-auto w-full max-w-7xl px-4 md:px-6">
        <div className="flex flex-col items-start justify-between gap-4 md:flex-row md:items-end">
          <div>
            <span className="inline-flex items-center gap-2 text-sm font-bold text-accent-600">
              <i className="ri-refresh-line"></i> 实时追更
            </span>
            <h2 className="mt-2 font-heading text-2xl font-black text-foreground-900 md:text-4xl">
              最新连载 · 追更不迷路
            </h2>
            <p className="mt-3 max-w-xl text-sm text-foreground-600 md:text-base">
              每日更新热门连载，第一时间掌握最新章节，不错过任何一段热血剧情。
            </p>
          </div>
          <span className="inline-flex items-center gap-2 rounded-full bg-secondary-100 px-4 py-2 text-xs font-bold text-secondary-800 md:text-sm">
            <span className="h-2 w-2 animate-pulse rounded-full bg-secondary-500"></span>
            今日已更新 12 部
          </span>
        </div>

        {/* 追更榜单 */}
        <div className="mt-8 overflow-hidden rounded-lg border border-background-200 bg-background-100">
          <div className="flex items-center gap-2 border-b border-background-200 bg-background-100 px-4 py-3">
            <i className="ri-trophy-fill text-accent-500"></i>
            <span className="font-heading text-sm font-bold text-foreground-900">实时追更热榜</span>
          </div>
          <div className="grid grid-cols-1 divide-y divide-background-200 sm:grid-cols-2 sm:divide-y-0 lg:grid-cols-5 lg:divide-x lg:divide-x-reverse lg:divide-y-0">
            {trendingList.map((item) => (
              <a
                key={item.rank}
                href="#latest"
                className="flex items-center gap-3 px-4 py-4 transition-colors hover:bg-background-50"
              >
                <span className="font-heading text-xl font-black text-primary-500">
                  {String(item.rank).padStart(2, "0")}
                </span>
                <div className="min-w-0 flex-1">
                  <p className="truncate text-sm font-bold text-foreground-900">{item.title}</p>
                  <p className="mt-0.5 flex items-center gap-2 text-xs text-foreground-500">
                    <span>{item.category}</span>
                    <span>{item.hot}</span>
                  </p>
                </div>
                <span className="shrink-0 text-xs font-bold text-accent-600">{item.delta}</span>
              </a>
            ))}
          </div>
        </div>

        {/* 最近更新列表 */}
        <div className="mt-10 grid grid-cols-1 gap-4 md:grid-cols-2 lg:grid-cols-3 md:gap-5">
          {latest.map((work) => (
            <article
              key={work.id}
              className="hover-lift flex items-center gap-4 rounded-lg border border-background-200 bg-background-50 p-3"
            >
              <div className="h-20 w-16 shrink-0 overflow-hidden rounded-md">
                <img
                  src={work.cover}
                  alt={`${work.title} 火影同人动漫最新更新`}
                  className="h-full w-full object-cover object-top"
                />
              </div>
              <div className="min-w-0 flex-1">
                <h3 className="truncate font-heading text-sm font-bold text-foreground-900">
                  {work.title}
                </h3>
                <p className="mt-1 text-xs text-foreground-500">{work.author}</p>
                <div className="mt-2 flex items-center justify-between">
                  <span className="inline-flex items-center gap-1 rounded bg-primary-100 px-2 py-0.5 text-[11px] font-bold text-primary-700">
                    <i className="ri-book-open-line"></i>
                    {work.chapters}
                  </span>
                  <span className="flex items-center gap-1 text-[11px] font-bold text-accent-600">
                    <i className="ri-time-line"></i>
                    {work.updated}
                  </span>
                </div>
              </div>
            </article>
          ))}
        </div>
      </div>
    </section>
  );
}